<template>
  <protocolList v-if="deviceTypeCode" :deviceTypeCode="deviceTypeCode"></protocolList>
</template>

<script>
import { DataCategoryApi } from '@wiz-api/data-category-management'
import protocolList from '../../../components/protocol-list'

const dataCategoryApi = new DataCategoryApi()
const deviceTypeNameKeyWord = '广播'
const unknowTypeName = '未知'
const componentName = 'broadcastProtocol'

export default {
  name: componentName,
  components: {
    protocolList,
  },
  data() {
    return {
      deviceTypeCode: '',
      deviceTypeList: [],
    }
  },
  methods: {
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateDeviceType') { // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        if (Array.isArray(deviceTypeList)) {
          for (let i = 0; i < deviceTypeList.length; i++) {
            const ele = deviceTypeList[i]
            if (ele.displayName.includes(deviceTypeNameKeyWord)) {
              this.deviceTypeCode = ele.code
            }
          }
          if (!this.deviceTypeCode) {
            const findUnknowType = deviceTypeList.find((item) => {
              return item.displayName.includes(unknowTypeName)
            })
            this.deviceTypeCode = findUnknowType.code
          }
        }
      }
    },
  },
  async created() {
    this.getCategoryByCodes()
  },
}
</script>

<style lang="scss" scoped></style>
